
const DebugConstruct = require('debug');
const vsprintf = require('sprintf-js').vsprintf;

// import {Http} from '@/network/http';
import axios from 'axios';


// let cache = 0;
export const SuperDebug = function(namespace, enabled = true) {
    if (enabled) {
        let instance        = DebugConstruct('wgc:' + namespace);
        // DebugConstruct.enable('*' + namespace + '*');
        // DebugConstruct.enable(namespace);
        DebugConstruct.enable('wgc:*');
        // console.log(['debug-enable', namespace, DebugConstruct.enabled(namespace)]);
        // if (!cache) {
            // console.log('enable');
            // cache = 1;
            // instance('enable');
        // }
        return  instance;
    } else {
        return function(first, ...rest) {}
    }
};


export const ServerDebug = function(namespace, empty) {

    return function(first, ...rest) {
        let str = vsprintf(first, rest);
        console.log('wgc:' + namespace + ' ' + str);

        let url = '/server/api-v1.0/debug/addLog';
        let data = {
            log: str,
            namespace: namespace
        };
        let callbacks = {
            success() {},
            fail() {},
            finally() {}
        };
        axios.post(url, data).then(callbacks.success).catch(callbacks.fail).finally(callbacks.finally);

        return () => {};

    }
};
